import React from 'react'
import { useParams } from 'react-router'
import HeaderTabLayout from '../components/HeaderTabLayout'
import Layout from '../components/Layout'
import Loader from '../components/Loader'
import SubCategoryView from '../components/version-4/viewForms/SubCategoryView'
import { useFeatures } from '../hooks/Features/useFeatures'
import { ROUTES } from '../shared/constants'

function ViewSubCategory() {
  const params = useParams()
  const { getSubCategory, subCategory } = useFeatures()

  React.useEffect(() => {
    getSubCategory({ subcategoryId: params.subcategoryId })
  }, [params.subcategoryId])

  return (
    <Layout heading="SubCategory" heading2="Info" url1={ROUTES.SUBCATEGORIES} none>
      {!subCategory ? (
        <Loader />
      ) : (
        <HeaderTabLayout
          heading="SubCategory"
          content={<SubCategoryView subcategory={subCategory} />}
          view
          url={`/edit-subcategory/${params.subcategoryId}`}
        />
      )}
    </Layout>
  )
}

export default ViewSubCategory
